function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { resolveBlockScalar } from '../compose/resolve-block-scalar.js';
import { resolveFlowScalar } from '../compose/resolve-flow-scalar.js';
import { YAMLParseError } from '../errors.js';
import { stringifyString } from '../stringify/stringifyString.js';

function resolveAsScalar(token) {
  var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var onError = arguments.length > 2 ? arguments[2] : undefined;

  if (token) {
    var _onError = function _onError(pos, code, message) {
      var offset = typeof pos === 'number' ? pos : Array.isArray(pos) ? pos[0] : pos.offset;
      if (onError) onError(offset, code, message);else throw new YAMLParseError([offset, offset + 1], code, message);
    };

    switch (token.type) {
      case 'scalar':
      case 'single-quoted-scalar':
      case 'double-quoted-scalar':
        return resolveFlowScalar(token, strict, _onError);

      case 'block-scalar':
        return resolveBlockScalar({
          options: {
            strict: strict
          }
        }, token, _onError);
    }
  }

  return null;
}
/**
 * Create a new scalar token with `value`
 *
 * Values that represent an actual string but may be parsed as a different type should use a `type` other than `'PLAIN'`,
 * as this function does not support any schema operations and won't check for such conflicts.
 *
 * @param value The string representation of the value, which will have its content properly indented.
 * @param context.end Comments and whitespace after the end of the value, or after the block scalar header. If undefined, a newline will be added.
 * @param context.implicitKey Being within an implicit key may affect the resolved type of the token's value.
 * @param context.indent The indent level of the token.
 * @param context.inFlow Is this scalar within a flow collection? This may affect the resolved type of the token's value.
 * @param context.offset The offset position of the token.
 * @param context.type The preferred type of the scalar token. If undefined, the previous type of the `token` will be used, defaulting to `'PLAIN'`.
 */


function createScalarToken(value, context) {
  var _context$end;

  var _context$implicitKey = context.implicitKey,
      implicitKey = _context$implicitKey === void 0 ? false : _context$implicitKey,
      indent = context.indent,
      _context$inFlow = context.inFlow,
      inFlow = _context$inFlow === void 0 ? false : _context$inFlow,
      _context$offset = context.offset,
      offset = _context$offset === void 0 ? -1 : _context$offset,
      _context$type = context.type,
      type = _context$type === void 0 ? 'PLAIN' : _context$type;
  var source = stringifyString({
    type: type,
    value: value
  }, {
    implicitKey: implicitKey,
    indent: indent > 0 ? ' '.repeat(indent) : '',
    inFlow: inFlow,
    options: {
      blockQuote: true,
      lineWidth: -1
    }
  });
  var end = (_context$end = context.end) !== null && _context$end !== void 0 ? _context$end : [{
    type: 'newline',
    offset: -1,
    indent: indent,
    source: '\n'
  }];

  switch (source[0]) {
    case '|':
    case '>':
      {
        var he = source.indexOf('\n');
        var head = source.substring(0, he);
        var body = source.substring(he + 1) + '\n';
        var props = [{
          type: 'block-scalar-header',
          offset: offset,
          indent: indent,
          source: head
        }];
        if (!addEndtoBlockProps(props, end)) props.push({
          type: 'newline',
          offset: -1,
          indent: indent,
          source: '\n'
        });
        return {
          type: 'block-scalar',
          offset: offset,
          indent: indent,
          props: props,
          source: body
        };
      }

    case '"':
      return {
        type: 'double-quoted-scalar',
        offset: offset,
        indent: indent,
        source: source,
        end: end
      };

    case "'":
      return {
        type: 'single-quoted-scalar',
        offset: offset,
        indent: indent,
        source: source,
        end: end
      };

    default:
      return {
        type: 'scalar',
        offset: offset,
        indent: indent,
        source: source,
        end: end
      };
  }
}
/**
 * Set the value of `token` to the given string `value`, overwriting any previous contents and type that it may have.
 *
 * Best efforts are made to retain any comments previously associated with the `token`,
 * though all contents within a collection's `items` will be overwritten.
 *
 * Values that represent an actual string but may be parsed as a different type should use a `type` other than `'PLAIN'`,
 * as this function does not support any schema operations and won't check for such conflicts.
 *
 * @param token Any token. If it does not include an `indent` value, the value will be stringified as if it were an implicit key.
 * @param value The string representation of the value, which will have its content properly indented.
 * @param context.afterKey In most cases, values after a key should have an additional level of indentation.
 * @param context.implicitKey Being within an implicit key may affect the resolved type of the token's value.
 * @param context.inFlow Being within a flow collection may affect the resolved type of the token's value.
 * @param context.type The preferred type of the scalar token. If undefined, the previous type of the `token` will be used, defaulting to `'PLAIN'`.
 */


function setScalarValue(token, value) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _context$afterKey = context.afterKey,
      afterKey = _context$afterKey === void 0 ? false : _context$afterKey,
      _context$implicitKey2 = context.implicitKey,
      implicitKey = _context$implicitKey2 === void 0 ? false : _context$implicitKey2,
      _context$inFlow2 = context.inFlow,
      inFlow = _context$inFlow2 === void 0 ? false : _context$inFlow2,
      type = context.type;
  var indent = 'indent' in token ? token.indent : null;
  if (afterKey && typeof indent === 'number') indent += 2;
  if (!type) switch (token.type) {
    case 'single-quoted-scalar':
      type = 'QUOTE_SINGLE';
      break;

    case 'double-quoted-scalar':
      type = 'QUOTE_DOUBLE';
      break;

    case 'block-scalar':
      {
        var header = token.props[0];
        if (header.type !== 'block-scalar-header') throw new Error('Invalid block scalar header');
        type = header.source[0] === '>' ? 'BLOCK_FOLDED' : 'BLOCK_LITERAL';
        break;
      }

    default:
      type = 'PLAIN';
  }
  var source = stringifyString({
    type: type,
    value: value
  }, {
    implicitKey: implicitKey || indent === null,
    indent: indent !== null && indent > 0 ? ' '.repeat(indent) : '',
    inFlow: inFlow,
    options: {
      blockQuote: true,
      lineWidth: -1
    }
  });

  switch (source[0]) {
    case '|':
    case '>':
      setBlockScalarValue(token, source);
      break;

    case '"':
      setFlowScalarValue(token, source, 'double-quoted-scalar');
      break;

    case "'":
      setFlowScalarValue(token, source, 'single-quoted-scalar');
      break;

    default:
      setFlowScalarValue(token, source, 'scalar');
  }
}

function setBlockScalarValue(token, source) {
  var he = source.indexOf('\n');
  var head = source.substring(0, he);
  var body = source.substring(he + 1) + '\n';

  if (token.type === 'block-scalar') {
    var header = token.props[0];
    if (header.type !== 'block-scalar-header') throw new Error('Invalid block scalar header');
    header.source = head;
    token.source = body;
  } else {
    var offset = token.offset;
    var indent = 'indent' in token ? token.indent : -1;
    var props = [{
      type: 'block-scalar-header',
      offset: offset,
      indent: indent,
      source: head
    }];
    if (!addEndtoBlockProps(props, 'end' in token ? token.end : undefined)) props.push({
      type: 'newline',
      offset: -1,
      indent: indent,
      source: '\n'
    });

    for (var _i = 0, _Object$keys = Object.keys(token); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (key !== 'type' && key !== 'offset') delete token[key];
    }

    Object.assign(token, {
      type: 'block-scalar',
      indent: indent,
      props: props,
      source: body
    });
  }
}
/** @returns `true` if last token is a newline */


function addEndtoBlockProps(props, end) {
  if (end) {
    var _iterator = _createForOfIteratorHelper(end),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var st = _step.value;

        switch (st.type) {
          case 'space':
          case 'comment':
            props.push(st);
            break;

          case 'newline':
            props.push(st);
            return true;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return false;
}

function setFlowScalarValue(token, source, type) {
  switch (token.type) {
    case 'scalar':
    case 'double-quoted-scalar':
    case 'single-quoted-scalar':
      token.type = type;
      token.source = source;
      break;

    case 'block-scalar':
      {
        var end = token.props.slice(1);
        var oa = source.length;
        if (token.props[0].type === 'block-scalar-header') oa -= token.props[0].source.length;

        var _iterator2 = _createForOfIteratorHelper(end),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var tok = _step2.value;
            tok.offset += oa;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        delete token.props;
        Object.assign(token, {
          type: type,
          source: source,
          end: end
        });
        break;
      }

    case 'block-map':
    case 'block-seq':
      {
        var offset = token.offset + source.length;
        var nl = {
          type: 'newline',
          offset: offset,
          indent: token.indent,
          source: '\n'
        };
        delete token.items;
        Object.assign(token, {
          type: type,
          source: source,
          end: [nl]
        });
        break;
      }

    default:
      {
        var indent = 'indent' in token ? token.indent : -1;

        var _end = 'end' in token && Array.isArray(token.end) ? token.end.filter(function (st) {
          return st.type === 'space' || st.type === 'comment' || st.type === 'newline';
        }) : [];

        for (var _i2 = 0, _Object$keys2 = Object.keys(token); _i2 < _Object$keys2.length; _i2++) {
          var key = _Object$keys2[_i2];
          if (key !== 'type' && key !== 'offset') delete token[key];
        }

        Object.assign(token, {
          type: type,
          indent: indent,
          source: source,
          end: _end
        });
      }
  }
}

export { createScalarToken, resolveAsScalar, setScalarValue };